import * as ACTION_TYPES from "@stores/actions/action_types";
import type { ActionType } from "@reducers/action";

/** Theme store actions historically use free-form fields (theme/option/…) instead of `payload`. */
const asAction = (action: Record<string, unknown>): ActionType =>
  action as unknown as ActionType;

export const get_themes = (response: unknown) => {
  return asAction({
    type: ACTION_TYPES.GET_LAYOUTS,
    ...(response as Record<string, unknown>),
  });
};
export const update_themes_success = (response: unknown) => {
  return asAction({
    type: ACTION_TYPES.UPDATE_LAYOUTS_SUCCESS,
    data: response,
  });
};
export const choose_theme = (new_theme: unknown) => {
  return asAction({
    type: ACTION_TYPES.CHOOSE_LAYOUT,
    new_theme,
  });
};
export const create_theme_success = (): ActionType => {
  return asAction({
    type: ACTION_TYPES.CREATE_THEME_SUCCESSFUL,
  });
};
export const show_theme = (theme: unknown): ActionType => {
  return asAction({
    type: ACTION_TYPES.SHOW_THEME,
    theme,
  });
};
export const open_option = (option: unknown): ActionType => {
  return asAction({
    type: ACTION_TYPES.OPEN_OPTION,
    option,
  });
};

export const open_navigate = (): ActionType => {
  return asAction({
    type: ACTION_TYPES.OPEN_NAVIGATE,
  });
};
export const change_theme = (theme: unknown): ActionType => {
  return asAction({
    type: ACTION_TYPES.CHANGE_THEME,
    theme,
  });
};
export const change_theme_successful = (): ActionType => {
  return asAction({
    type: ACTION_TYPES.CHANGE_THEME_SUCCESSFUL,
  });
};

export const update_theme = (): ActionType => {
  return asAction({
    type: ACTION_TYPES.UPDATE_THEME,
  });
};
export const update_theme_successful = (): ActionType => {
  return asAction({
    type: ACTION_TYPES.UPDATE_THEME_SUCCESSFUL,
  });
};
export const update_preview_theme = (is_update_preview: unknown): ActionType => {
  return asAction({
    type: ACTION_TYPES.UPDATE_PREVIEW_THEME,
    is_update_preview,
  });
};
export const preview_theme = (output: unknown): ActionType => {
  return asAction({
    type: ACTION_TYPES.PREVIEW_THEME,
    output,
  });
};
export const update_theme_completed = (): ActionType => {
  return asAction({
    type: ACTION_TYPES.UPDATE_THEME_COMPLETED,
  });
};
